import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const PLANK_MOBILE_HEIGHT = 72;

export const PlankWrap = styled.div<{ isShows: boolean }>`
    display: none;
    min-width: 320px;
    width: 100%;
    height: 0;
    z-index: 12;
    background: ${COLORS.BgMain};
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        display: flex;
        height: ${p => p.isShows ? `${PLANK_MOBILE_HEIGHT}px` : '0'};
    }
`;
